import {GoPageRootComponent} from "./go-page-root.component";
import {GoPageComponent} from "./go-page.component";
import {GO_CATEGORIES as CAT, GO_COMPONENTS as COMP} from "../../enums/e-game-objects";
import {IGoPageConfig} from "../../definitions";
import {UnsavedGuard} from "../../services/unsaved-guard.service";
import {Routes} from "@angular/router";


export const GoPageRoutes: Routes = [
    {
        path: "gameObjects",
        component: GoPageRootComponent,
        data: { name: "Гейм-объекты" },
        children: [
            {
                path: "buildings",
                component: GoPageComponent,
                canDeactivate: [UnsavedGuard],
                data: pageConf(
                    "Здания",
                    [CAT.HOUSE, CAT.COMMON_BUILDING, CAT.PASTURE,
                      CAT.FARM_CELL/*, CAT.LAIR, CAT.STORAGE_COMMON, CAT.STORAGE_MANA*/],
                    [COMP.RENDER, COMP.BOUNDS, COMP.WORK, COMP.LIMITED, COMP.SHOP,
                        COMP.RES_TRANSACTION, COMP.HOUSE, COMP.INFLUENCE_RECEIVER,
                        COMP.FLOATING_COST, COMP.PASTURE, /*COMP.LAIR,*/ COMP.TAGS, COMP.GAME_EVENTS/*, COMP.ORDERS*/]
                )
            },
          /*{
            path: "achievement_houses",
            document: GoPageComponent,
            canDeactivate: [UnsavedGuard],
            data: pageConf(
              "Дом ачивок",
              [CAT.ACHIEVEMENT_HOUSE],
              [COMP.BOUNDS, COMP.WORK, COMP.TAGS, COMP.GAME_EVENTS]
            )
          },*/
            {
                path: "garbage",
                component: GoPageComponent,
                canDeactivate: [UnsavedGuard],
                data: pageConf(
                    "Мусор",
                    [CAT.GARBAGE, CAT.TREE],
                    [COMP.RENDER, COMP.BOUNDS, COMP.WORK, COMP.TAGS, COMP.INFLUENCE_SENDER, COMP.GAME_EVENTS, COMP.INFLUENCE_RECEIVER]
                )
            },
            {
                path: "decor",
                component: GoPageComponent,
                canDeactivate: [UnsavedGuard],
                data: pageConf(
                    "Декор",
                    [CAT.DECOR],
                    [COMP.RENDER, COMP.BOUNDS, COMP.RES_TRANSACTION, COMP.SHOP, COMP.TAGS, COMP.GAME_EVENTS]
                )
            },
            {
              path: "live_decor",
              component: GoPageComponent,
              canDeactivate: [UnsavedGuard],
              data: pageConf(
                "Живой декор",
                [CAT.LIVE_DECOR],
                [COMP.RENDER, COMP.LIVE_DECOR, COMP.GAME_EVENTS, COMP.TAGS]
              )
            },
            {
                path: "roads",
                component: GoPageComponent,
                canDeactivate: [UnsavedGuard],
                data: pageConf(
                    "Дороги и заборы",
                    [CAT.ROAD],
                    [COMP.RENDER, COMP.RES_TRANSACTION, COMP.SHOP, COMP.TAGS, COMP.GAME_EVENTS]
                )
            },
            {
                path: "special",
                component: GoPageComponent,
                canDeactivate: [UnsavedGuard],
                data: pageConf(
                    "Особые постройки",
                    [CAT.MARKET, CAT.ZEPPELIN, CAT.SHOP_KEEPER, CAT.ACHIEVEMENT_HOUSE, CAT.STORAGE_COMMON, CAT.ORDERS_HOST, CAT.EVENT_STARTER],
                    [COMP.RENDER, COMP.BOUNDS, /*COMP.RES_TRANSACTION, COMP.LIMITED,*/ COMP.WORK, COMP.TAGS, COMP.GAME_EVENTS, COMP.STORAGE, COMP.ORDERS, COMP.EVENT_STARTER, COMP.GAME_TASK, COMP.INFLUENCE_RECEIVER]
                )
            },
            {
                path: "animals",
                component: GoPageComponent,
                canDeactivate: [UnsavedGuard],
                data: pageConf(
                    "Животные",
                    [CAT.ANIMAL],
                    [COMP.RENDER, COMP.FLOATING_COST, COMP.RES_TRANSACTION, COMP.WORK, COMP.SHOP, COMP.MOVE, COMP.TAGS, COMP.GAME_EVENTS, COMP.PERIODICAL_REWARD]
                )
            },
            {
                path: "plants",
                component: GoPageComponent,
                canDeactivate: [UnsavedGuard],
                data: pageConf(
                    "Растения",
                    [CAT.PLANT],
                    [COMP.RENDER, COMP.PLANT, COMP.SHOP, COMP.TAGS, COMP.GAME_EVENTS]
                )
            },
            {
                path: "resources",
                component: GoPageComponent,
                canDeactivate: [UnsavedGuard],
                data: pageConf(
                    "Ресурсы",
                    [CAT.STUFF],
                    [COMP.RENDER, COMP.RESOURCE, COMP.TAGS, COMP.GAME_EVENTS, COMP.GAME_TASK]
                )
            },
            /*{
                path: "shop_lots",
                document: GoPageComponent,
                canDeactivate: [UnsavedGuard],
                data: pageConf(
                    "Магазин - ресурсы",
                    [CAT.STUFF_PACK],
                    [COMP.RES_TRANSACTION]
                )
            },*/
            {
             path:"landscape",
                component: GoPageComponent,
                canDeactivate: [UnsavedGuard],
                data: pageConf(
                    "Элементы ландшафта",
                    [CAT.LANDSCAPE],
                    [COMP.RENDER, COMP.BOUNDS, COMP.TAGS, COMP.GAME_EVENTS]
                )
            },
            {
              path:"characters",
              component: GoPageComponent,
              canDeactivate: [UnsavedGuard],
              data: pageConf(
                "Персонажи",
                [CAT.SHMU, CAT.NPC, CAT.DIRIGIBLE, CAT.FLYING_CAT],
                [COMP.RENDER, COMP.GAME_EVENTS, COMP.ORDERS]
              )
            },
            {
              path:"talkingHeads",
              component: GoPageComponent,
              canDeactivate: [UnsavedGuard],
              data: pageConf(
                "Говорящие головы",
                [ CAT.TALKING_HEAD],
                [COMP.RENDER, COMP.GAME_EVENTS]
              )
            },
            {
              path:"misc",
              component: GoPageComponent,
              canDeactivate: [UnsavedGuard],
              data: pageConf(
                "Разное",
                [CAT.SCAFFOLD, CAT.BALLOONS],
                [COMP.RENDER, COMP.GAME_EVENTS]
              )
            }
        ]
    }
];


export function pageConf(name: string,
                  categories: string[],
                  components: string[]): IGoPageConfig {
    return {
        name: name,
        categories: categories,
        components: components
    };
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/pages/go/go-page-routing.module.ts